import React from "react";
import { Button } from "antd";
import { LuArrowLeft } from "react-icons/lu";

const CustomBackButton = ({
  onBack,
  buttonText = "Back",
  // Sized rather than inherited: lucide icons carry no font-size of their own,
  // so without this the arrow would render at the icon default and sit small
  // against the heading beside it.
  buttonIcon = <LuArrowLeft size={18} />,
  iconPosition = "left",
  className = "",
  leftExtra = null,
  extraa = null,
}) => {
  return (
    <div className="flex items-center justify-between gap-2 mb-6">
      <div className="flex items-center flex-1">
        <Button
          type="text"
          iconPosition={iconPosition}
          icon={buttonIcon}
          onClick={onBack}
          className={className}
        />
        <h2 className="text-xl font-medium">{buttonText}</h2>
        {leftExtra && <div className="ml-4">{leftExtra}</div>}
      </div>
      {extraa && <div className="ml-auto">{extraa}</div>}
    </div>
  );
};

export default CustomBackButton;
